import React, { Component, Fragment } from "react";
import Panel from "../GoPlanner/components/Panel";
import { PLANNER_STORAGE_KEY } from "./utils/constants";
import Dropdown from "../GoPlanner/form/Dropdown";
import { addOrRemoveItem } from "./AddButton";
import xhr from "xhr";
import { API_LINK } from "../GoPlanner/util/constants";

class EnquirePage extends Component {
    state = {
        panels: [],
        name: "",
        email: "",
        phone: "",
        location: "",
        message: "",
        subscribe: false,
        submitted: false,
        loading: false,
    };

    componentDidMount() {
        this.setState({
            panels: JSON.parse(localStorage.getItem(PLANNER_STORAGE_KEY)) || [],
        });
    }

    render() {
        const { panels } = this.state;

        return (
            <div className="enquire-page">
                <div className="enquire-page__grid">
                    <div className="enquire-page__wrap">
                        <div className="enquire-page__head">
                            <h3>Your interest list</h3>
                            {!!panels.length && (
                                <button
                                    onClick={() => {
                                        if (
                                            confirm(
                                                "Are you sure you want to clear the selection?"
                                            )
                                        ) {
                                            localStorage.setItem(
                                                PLANNER_STORAGE_KEY,
                                                JSON.stringify([])
                                            );
                                            this.setState({
                                                panels: [],
                                            });
                                        }
                                    }}
                                >
                                    Clear All
                                </button>
                            )}
                        </div>
                        {!!panels.length ? (
                            <div className="card-grid">
                                {panels.map((panel) => (
                                    <Panel
                                        key={"panel-" + panel.id}
                                        panel={panel}
                                        noLinks
                                        showClose
                                        splitViewPanel
                                        isEnquirePage
                                        onClose={() => {
                                            addOrRemoveItem(panel);
                                            const newPanels = panels.filter(
                                                (p) => p.id !== panel.id
                                            );
                                            this.setState({
                                                panels: newPanels,
                                            });
                                        }}
                                    />
                                ))}
                            </div>
                        ) : (
                            <p>There are no locations added!</p>
                        )}
                    </div>
                    <div className="form">
                        <div className="form__content">
                            <h3>Enquiry Form</h3>
                            {!!this.props.settings.formContent && (
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: this.props.settings.formContent.replace(
                                            /(?:\r\n|\r|\n)/g,
                                            "<br>"
                                        ),
                                    }}
                                />
                            )}
                        </div>
                        <div className="form__form">{this.renderForm()}</div>
                    </div>
                </div>
            </div>
        );
    }

    renderForm() {
        const { loading, submitted } = this.state;
        const { settings } = this.props;

        if (loading) {
            return <p>Your enquiry is being submitted...</p>;
        }

        if (submitted) {
            return (
                <p>
                    Thank you for your enquiry. We'll be in touch with you soon!
                </p>
            );
        }

        return (
            <form onSubmit={(e) => this.onSubmit(e)} id={"enquire-form"}>
                <div className="field text">
                    <input
                        type="text"
                        required
                        onChange={(e) =>
                            this.onChangeField("name", e.target.value)
                        }
                        placeholder="Name"
                    />
                </div>
                <div className="field text">
                    <input
                        type="email"
                        required
                        onChange={(e) =>
                            this.onChangeField("email", e.target.value)
                        }
                        placeholder="E-mail"
                    />
                </div>
                <div className="field text">
                    <input
                        type="text"
                        onChange={(e) =>
                            this.onChangeField("phone", e.target.value)
                        }
                        placeholder="Phone Number"
                    />
                </div>
                <div className="field dropdown">
                    <Dropdown
                        required
                        onChange={(e) =>
                            this.onChangeField("location", e.target.value)
                        }
                        placeholder="Location"
                        options={settings.locations}
                    />
                </div>
                <div className="field textarea">
                    <textarea
                        required
                        onChange={(e) =>
                            this.onChangeField("message", e.target.value)
                        }
                        placeholder="Message"
                        rows={5}
                    />
                </div>
                <div className="field checkbox">
                    <input
                        type="checkbox"
                        onChange={(e) =>
                            this.onChangeField("subscribe", e.target.checked)
                        }
                    />
                    <label htmlFor="subscribeCheckbox">
                        Please subscribe me for latest news and insights
                    </label>
                </div>

                <div className="actions">
                    <button type="submit" className="button">
                        Send Enquiry
                    </button>
                </div>
            </form>
        );
    }

    onChangeField(name, value) {
        this.setState({
            [name]: value,
        });
    }

    onSubmit(e) {
        e.preventDefault();

        const xhr = require("xhr");
        const { name, email, location, phone, message, subscribe, panels } =
            this.state;
        const variables = {
            Name: name,
            Email: email,
            Phone: phone,
            NearestLocationID: location,
            Message: message,
            Subscribe: subscribe,
            Panels: panels.map((panel) => panel.id),
        };
        this.setState({ loading: true });
        xhr.post(
            this.props.link,
            { body: JSON.stringify(variables) },
            (error, resp) => {
                this.setState({
                    loading: false,
                    submitted: true,
                    panels: [],
                });
                const status = resp.statusCode;
                if (status >= 200 && status < 400) {
                    dataLayer.push({
                        event: "Form Submit",
                        formName: "Enquire Now",
                        formID: "enquire-form",
                    });
                }

                localStorage.setItem(PLANNER_STORAGE_KEY, JSON.stringify([]));
            }
        );

        return false;
    }
}

export default EnquirePage;
